import { render, staticRenderFns } from "./WarningWindow.vue?vue&type=template&id=a55442f4&scoped=true&"
import script from "./WarningWindow.vue?vue&type=script&lang=js&"
export * from "./WarningWindow.vue?vue&type=script&lang=js&"
import style0 from "./WarningWindow.vue?vue&type=style&index=0&id=a55442f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55442f4",
  null
  
)

export default component.exports